import { z } from 'zod';

export const DiscoveryFormSchema = z.object({
  // Section 1: Ecosistema del Negocio y Rentabilidad
  businessName: z.string().min(1, 'Dinos el nombre de tu marca'),
  niche: z.string().min(1, 'Escribe tu nicho o profesión'),
  averageTicket: z.number().min(1, 'Ingresa un monto'),
  idealClient: z.string().min(1, 'Cuéntanos un poco sobre tu cliente ideal'),
  antiClient: z.string().min(1, 'Dinos a quién prefieres no atender'),

  // Sección 1b: Psicología Profunda
  catalyst: z.string().min(1, 'Dinos qué los motiva a buscarte'), 
  priorTrauma: z.string().min(1, 'Cuéntanos un poco sobre sus malas experiencias'),
  secretFear: z.string().min(1, 'Dinos qué miedo o duda tienen'),

  // Section 2: Fricción y Barreras Ocultas
  mainObjection: z.string().min(1, 'Dinos por qué suelen dudar al agendar'),
  currentProblem: z.string().min(1, 'Cuéntanos qué falla en tu proceso hoy'),
  competition: z.string().min(1, 'Dinos algo sobre tu competencia'),

  // Section 3: La Oferta Irresistible
  corePromise: z.string().min(1, 'Dinos qué transformación prometes'),
  uniqueValue: z.string().min(1, 'Dinos qué te hace especial'),

  // Sección 4: Matemática del Negocio
  returnFrequency: z.string().min(1, 'Dinos cada cuánto vuelven'),

  // Sección 4b: Capacidad Operativa
  capacityCeiling: z.string().min(1, 'Dinos cuántos puedes atender'),
  suggestedMonthlyBudget: z.number().min(0).optional(),
  suggestedDailyBudget: z.number().min(0).optional(),

  // Section 5: Pacto de Expectativas
  timeExpectation: z.enum(['urgent', 'realistic']),

  isCompleted: z.boolean().optional().default(false),
});

export type DiscoveryFormData = z.infer<typeof DiscoveryFormSchema>;

export interface MarketingConfig {
  pixelId: string; // Redundante aquí para facilitar el fetch de la API
  accessToken: string; // El token de larga duración de la CAPI
  testEventCode?: string; // Código "TESTXXXX" para depuración
  isMasterEnabled: boolean;
  isAdsEnabled?: boolean; // Controlado por el admin para habilitar la orden de inversión
  isManaged?: boolean; // Si el admin gestiona todo
  discovery?: DiscoveryFormData;
  updatedAt: any; // Timestamp
}

export const MarketingThreadSchema = z.object({
  id: z.string(), // Phone number or unique ID
  ownerId: z.string(),
  campaignId: z.string(),
  phoneNumber: z.string(),
  aiEnabled: z.boolean().default(true),
  lastMessageAt: z.any(), // Timestamp
  lastMessageText: z.string().optional(),
  clientName: z.string().optional(),
  unreadCount: z.number().default(0),
  status: z.enum(['active', 'paused', 'completed']).default('active'),
  metadata: z.record(z.string(), z.any()).default({}),
});

export type MarketingThread = z.infer<typeof MarketingThreadSchema>;
